<template>
    <Dialog :dialog="dlg" no-content-padding>
        <template v-slot:tabs-left>
            <v-tabs dense v-model="dlg.tab">        
                <v-tab>Medewerker</v-tab>
                <v-tab :disabled="model.isLoading" v-if="feature.canHours||feature.canPlanning">Instellingen</v-tab>
                <v-tab :disabled="model.isLoading">Tarieven</v-tab>
                <v-tab :disabled="model.isLoading">App toegang</v-tab>
            </v-tabs>
        </template>

        <v-tabs-items class="product-tabs xmt-2" v-model="dlg.tab">                
            <v-tab-item class="restore-content-padding" transition="fade-transition" reverse-transition="fade-transition">                        
                <v-form ref="formHeader" lazy-validation>
                    <Form sm="12-12" lg="6-6">
                        <FormRow label="Naam">     
                            <v-row dense >
                                <v-col sm="5">
                                    <TextField dusk="firstname" :model="model" max-length="128" placeholder="Voornaam" :rules="model.rules.firstname"  v-model="model.firstname"></TextField>
                                </v-col>            
                                <v-col sm="7">
                                    <TextField dusk="lastname" :model="model" max-length="128" placeholder="Achternaam" :rules="model.rules.lastname"  v-model="model.lastname"></TextField>
                                </v-col>            
                            </v-row>

                        </FormRow>
                        <FormRow label="E-mail">            
                            <TextField dusk="email" :model="model" max-length="128" placeholder="E-mail" :rules="model.rules.email"  v-model="model.email"></TextField>
                        </FormRow>

                        <FormRow label="Telefoonnummer">
                            <TextField dusk="mobile" :model="model" max-length="128" placeholder="Telefoonnummer" :rules="model.rules.mobile" v-model="model.mobile"></TextField>
                        </FormRow>
                        <FormRow label="Geboortedatum">
                            <DatePicker dusk="birthday" :model="model" max-length="128" :rules="model.rules.birthday" v-model="model.birthday"></DatePicker>
                        </FormRow>
                        <FormRow label="BSN-nummer">
                            <TextField dusk="bsn" :model="model" max-length="128" placeholder="BSN-nummer" :rules="model.rules.bsn" v-model="model.bsn"></TextField>
                        </FormRow>
                        <FormRow label="Adres">
                            <v-row dense >
                                <v-col class="col-9">
                                    <TextField dusk="adr_street" :model="model" max-length="255" placeholder="Straatnaam" :rules="model.rules.adr_street" v-model="model.adr_street"></TextField>
                                </v-col>            
                                <v-col class="col-3">
                                    <TextField dusk="adr_street_number" :model="model" max-length="45" placeholder="Nr" :rules="model.rules.adr_street_number" v-model="model.adr_street_number"></TextField>
                                </v-col>            
                            </v-row>
                        </FormRow>
                        <FormRow>
                            <v-row dense>
                                <v-col class="col-4">
                                    <TextField dusk="adr_zipcode" :model="model" max-length="45" placeholder="Postcode" :rules="model.rules.adr_zipcode" v-model="model.adr_zipcode"></TextField>
                                </v-col>            
                                <v-col class="col-8">
                                    <TextField dusk="adr_city" :model="model" max-length="255" placeholder="Plaats" :rules="model.rules.adr_city" v-model="model.adr_city"></TextField>
                                </v-col>            
                            </v-row>
                        </FormRow>
                        <FormRow>            
                            <CountryCombo dusk="country_code" :model="model" :rules="model.rules.country_code" v-model="model.country_code"></CountryCombo>
                        </FormRow>
                        <FormRow label="Functie">
                            <JobtitleCombo dusk="id_jobtitle" :model="model" :rules="model.rules.id_jobtitle" v-model="model.id_jobtitle"></JobtitleCombo>
                        </FormRow>
                        <FormRow label="Afdeling">
                            <DepartmentCombo dusk="id_department" :model="model" :rules="model.rules.id_department" v-model="model.id_department"></DepartmentCombo>
                        </FormRow>
                        <FormRow label="Ingehuurd van">
                            <RelationCombo dusk="id_relation" :model="model" :rules="model.rules.id_relation" v-model="model.id_relation"></RelationCombo>
                        </FormRow>
                        <template v-slot:right>
                            <FormRow label="Werktijden">
                                <template v-slot:label>
                                    <div class="v-top">
                                        <label class="clsLabel mr-2">Werktijden</label>
                                        <TipMenu left>
                                            <h4>Werktijden specificatie</h4>
                                            <p>
                                                Wanneer u de medewerker werktijden specificeert worden deze gegevens gebruikt om standaardwaarden in de 
                                                buitendienst app in te vullen.
                                            </p>
                                            <h4>Van- en tot tijd</h4>
                                            <p>
                                                Het invullen van de werktijden is optioneel. Wanneer u deze tijden invult worden deze tijden gebruikt om de standaard werktijden van deze medewerker in te vullen in de buitendienst app.
                                            </p>
                                            <h4>Uren per dag</h4>
                                            <p>
                                                Dit is het aantal uren dat deze medewerker per dag werkt. Wanneer u de van- en tot tijd invult wordt deze waarde berekend, maar het staat vrij om hiervan af te wijken.
                                            </p>
                                        </TipMenu>

                                    </div>
                                </template>

                                <v-row dense class="mb-2">
                                    <v-col class="pl-2">Van</v-col>
                                    <v-col class="pl-2">Tot</v-col>
                                    <v-col class="pl-2">Uren</v-col>
                                </v-row>
                            </FormRow>
                            <FormRow label="Maandag">            
                                <v-row dense>
                                    <v-col><TimeField hm block dusk="start_time_minutes_mon" :model="model" v-model="model.gs_start_time_minutes_mon"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="end_time_minutes_mon" :model="model" v-model="model.gs_end_time_minutes_mon"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="workday_minutes_mon" :model="model" v-model="model.workday_minutes_mon"></TimeField></v-col>
                                </v-row>
                            </FormRow>
                            <FormRow label="Dinsdag">            
                                <v-row dense>
                                    <v-col><TimeField hm block dusk="start_time_minutes_tue" :model="model" v-model="model.gs_start_time_minutes_tue"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="end_time_minutes_tue" :model="model" v-model="model.gs_end_time_minutes_tue"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="workday_minutes_tue" :model="model" v-model="model.workday_minutes_tue"></TimeField></v-col>
                                </v-row>
                            </FormRow>
                            <FormRow label="Woensdag">            
                                <v-row dense>
                                    <v-col><TimeField hm block dusk="start_time_minutes_wed" :model="model" v-model="model.gs_start_time_minutes_wed"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="end_time_minutes_wed" :model="model" v-model="model.gs_end_time_minutes_wed"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="workday_minutes_wed" :model="model" v-model="model.workday_minutes_wed"></TimeField></v-col>
                                </v-row>
                            </FormRow>
                            <FormRow label="Donderdag">            
                                <v-row dense>
                                    <v-col><TimeField hm block dusk="start_time_minutes_thu" :model="model" v-model="model.gs_start_time_minutes_thu"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="end_time_minutes_thu" :model="model" v-model="model.gs_end_time_minutes_thu"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="workday_minutes_thu" :model="model" v-model="model.workday_minutes_thu"></TimeField></v-col>
                                </v-row>
                            </FormRow>
                            <FormRow label="Vrijdag">            
                                <v-row dense>
                                    <v-col><TimeField hm block dusk="start_time_minutes_fri" :model="model" v-model="model.gs_start_time_minutes_fri"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="end_time_minutes_fri" :model="model" v-model="model.gs_end_time_minutes_fri"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="workday_minutes_fri" :model="model" v-model="model.workday_minutes_fri"></TimeField></v-col>
                                </v-row>
                            </FormRow>
                            <FormRow label="Zaterdag">            
                                <v-row dense>
                                    <v-col><TimeField hm block dusk="start_time_minutes_sat" :model="model" v-model="model.gs_start_time_minutes_sat"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="end_time_minutes_sat" :model="model" v-model="model.gs_end_time_minutes_sat"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="workday_minutes_sat" :model="model" v-model="model.workday_minutes_sat"></TimeField></v-col>
                                </v-row>
                            </FormRow>
                            <FormRow label="Zondag">            
                                <v-row dense>
                                    <v-col><TimeField hm block dusk="start_time_minutes_sun" :model="model" v-model="model.gs_start_time_minutes_sun"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="end_time_minutes_sun" :model="model" v-model="model.gs_end_time_minutes_sun"></TimeField></v-col>
                                    <v-col><TimeField hm block dusk="workday_minutes_sun" :model="model" v-model="model.workday_minutes_sun"></TimeField></v-col>
                                </v-row>
                            </FormRow>
                            <FormRow label="">            
                                <v-row dense>
                                    <v-col></v-col>
                                    <v-col class="pl-4">Totaal</v-col>
                                    <v-col><TimeField :max24="false" disabled hm block dusk="workday_minutes_total" :model="model" v-model="model.workday_minutes_total"></TimeField></v-col>
                                </v-row>
                            </FormRow>

                            <v-row dense>
                                <v-col>&nbsp;</v-col>
                                <v-col></v-col>
                            </v-row>

                            
                            <FormRow label="">      
                                <template v-slot:label>
                                    <div class="v-top">
                                        <label class="clsLabel mr-2">Contracturen per week</label>
                                        <TipMenu left>
                                            <h4>Contracturen per week</h4>
                                            <p>
                                                Met deze optie geeft u het aantal uren op dat deze medewerker normaal gesproken per week werkt. <br>
                                                Deze waarde hoeft niet overeen te komen met het berekende totaal van de werktijden. Dit omdat afhankelijk van het beloningsbeleid van de organisatie bijvoorbeeld wel of geen pauze wordt doorberekend.                                                 
                                            </p>
                                            <p>
                                                Deze waarde ziet u terug in het uren beheerscherm in Optimit, en in de buitendienst app zodat de medewerker weet hoeveel uren per week worden verwacht. <br>
                                            </p>
                                        </TipMenu>

                                    </div>
                                </template>
      
                                <v-row dense>
                                    <v-col></v-col>
                                    <v-col></v-col>
                                    <v-col><TimeField hm :max24="false" block dusk="empl_workweek_minutes" :model="model" v-model="model.empl_workweek_minutes"></TimeField></v-col>
                                </v-row>
                            </FormRow>
                        </template>

                    </Form>
                </v-form>
                </v-tab-item>
                <v-tab-item v-if="feature.canHours||feature.canPlanning" class="restore-content-padding" transition="fade-transition" reverse-transition="fade-transition">                        
                    <v-form ref="formSettings">
                        <FormRow v-if="feature.canHours" label="Genereer automatisch urenlijst" subLabel="Wekelijks wordt een nieuwe urenlijst aangemaakt">            
                            <Checkbox switcher dusk="empl_gen_hourlist" :model="model" v-model="model.empl_gen_hourlist"></Checkbox>
                        </FormRow>
                        <FormRow v-if="feature.canPlanning" label="Medewerker mag worden ingepland">            
                            <Checkbox switcher dusk="empl_is_plannable" :model="model" v-model="model.empl_is_plannable"></Checkbox>
                        </FormRow>
                    </v-form>
                </v-tab-item>
                <v-tab-item transition="fade-transition" reverse-transition="fade-transition">                        
                        <LocalTable :model="model" modelLinesProp='tariffs' dense :dt="tblLocal">
                            <template v-slot:menu="{ item }">
                                <ActionMenuItem dusk="action-employee_tariff.open" action="employee_tariff.open" @click="() => openTariff(item)">Wijzig tarief</ActionMenuItem>
                            </template>
                            <template v-slot:item.amount_extern="{ item }">
                                <span v-if="item.amount_extern === null">-</span>
                                <AmountColumn dusk="amount_extern" v-else :value="item.amount_extern"></AmountColumn>
                            </template>
                            <template v-slot:item.amount_intern="{ item }">
                                <span v-if="item.amount_intern === null">-</span>
                                <AmountColumn dusk="amount_extern" v-else :value="item.amount_intern"></AmountColumn>
                            </template>
                            <template v-slot:item.name="{ item }">
                                <span class="cursor-pointer primary--text" :color="'primary'" @click="() => openTariff(item)">
                                    {{item.name}}
                                </span>
                            </template>

                        </LocalTable>

                </v-tab-item>
                <v-tab-item transition="fade-transition" reverse-transition="fade-transition">                        
                    <TabAppAccess :dlg="dlg" :model="model"></TabAppAccess>
                </v-tab-item>

        </v-tabs-items>
        
    </Dialog>
</template>



<script setup>
    import useModel from '@/features/settings/employees/model/employee'
    import Form from '@controls/forms/Form'
    import FormColumn from '@controls/forms/FormColumn'
    import FormRow from '@controls/forms/FormRow'
    import TextField from '@controls/input/TextField'
    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import DepartmentCombo from '@controls/combo/Department'
    import JobtitleCombo from '@controls/combo/Jobtitle'
    import RelationCombo from '@controls/combo/Relation'
    import TimeField from '@controls/input/TimeField'
    import CountryCombo from '@controls/combo/Country'
    import DatePicker from '@controls/input/DatePicker'
    import Checkbox from "@controls/check/Checkbox";
    import { ref, computed } from 'vue'
    import clsDialog from '@cls/clsDialog'
    import LocalTable from '@datatable/LocalTable'  
    import clsLocalTable from '@cls/clsLocalTable'
    import ActionMenuItem from "@controls/menu/ActionMenuItem.vue";
    import AmountColumn from '@datatable/columns/Amount'
    import TipMenu from "@controls/menu/TipMenu.vue";
    import noty from '@lib/noty'
    import libDlg from '@app/dlg'
    import feature from '@app/features'
    import TabAppAccess from './TabAppAccess.vue'

    const formHeader = ref(null);
    const formSettings = ref(null);

    let model = useModel();
    let dlg = ref(
        new clsDialog("employee", "Medewerker", model, [formHeader, formSettings], {
            maxWidth: "1200px",
            showNote: true,
            noteType: 'employee_note',
            showAttachment: true,
            showFlag: true,
            flagType: 'employee', // No specific right for employee_flag.
            attachmentType: 'employee_attachment',
        } )).value;

    let headers = [
        { "type": "cmd" }, 
        { "text": "Tarief", "value": "name"}, 
        { "text": "Interne kosten", "value": "amount_intern" }, 
        { "text": "Externe kosten", "value": "amount_extern" }, 
        { isUtc: true, "text": "Gewijzigd", "value": "updated_at" }, 
        { "text": "Door", "value": "updated_by" }, 
    ];
    
    
    let tblLocal = new clsLocalTable("employee_tariff", headers, {
        noDataText: "Er zijn geen tarieven beschikbaar",
        model: model, 
        modelLinesProp: "tariffs"    
    });

    function applyNew() {
        console.error('not implemented')
    }

    async function openTariff(item) {
        if (model.isNew) {
            await noty.confirm("De medewerker zal eerst worden opgeslagen. Wilt u doorgaan?");
            let result = await dlg.onSave(true);
            if (result === false) {
                return; // Validation failed.
            }
        }
        item.id_employee = model.id;

        let saved = await libDlg.promised.open('employee_tariff', item)
        model.updateTariff(saved);

    }
    window.em = dlg;

</script>
